import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ButtonIcon} from '@homeaway/react-buttons';
import {CLOSE__24} from '@homeaway/svg-defs';
import classNames from 'classnames';
import './NotificationBar.less';

class NotificationBar extends Component {
    static propTypes = {
        messages: PropTypes.arrayOf(PropTypes.node),
        onDismissBar: PropTypes.func,
        onDismissMessage: PropTypes.func,
        show: PropTypes.bool
    };

    static defaultProps = {
        messages: [],
        onDismissBar: () => { },
        onDismissMessage: () => { },
        show: false
    };

    constructor(props) {
        super(props);
        this.state = {
            currentMessageIndex: 0,
            messageRefs: [],
            visible: false
        };
    }

    componentDidMount() {
        this.setState({visible: this.props.show});
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentMessageIndex < prevProps.messages.length && prevProps.show && !prevState.visible) {
            this.setState({visible: prevProps.show});
        }
    }

    onDismissMessage = () => {
        const nextIdx = this.state.currentMessageIndex + 1;
        this.props.onDismissMessage();
        if (nextIdx >= this.props.messages.length) {
            this.props.onDismissBar();
            this.setState({visible: false});
        }
        this.setState({
            currentMessageIndex: nextIdx
        });
    }

    renderMessages = (messages) => {
        let messageDivs = [];
        messages.map((message, idx) => {
            const id = `NotificationBar__message--${idx}`;
            const isCurrent = (idx === this.state.currentMessageIndex);
            const messageClasses = classNames(
                'NotificationBar__message',
                isCurrent ? 'shown' : 'hidden'
            );
            let messageDiv = (
                <div className={messageClasses}
                    id={id}
                    key={id}
                >
                    {message}
                </div>
            );
            messageDivs.push(messageDiv);
        });
        return messageDivs;
    }

    render() {
        const {messages} = this.props;
        return this.state.visible && (
            <div
                className="NotificationBar"
                role="alert"
                aria-live="polite"
            >
                <div className="NotificationBar__content">
                    <div className="NotificationBar__messages">
                        {this.renderMessages(messages)}
                    </div>
                    <ButtonIcon
                        className="NotificationBar__close"
                        label="Close"
                        onClick={this.onDismissMessage}
                        svgMarkup={CLOSE__24}
                        size="xs"
                        inverse
                    />
                </div>
            </div>
        );
    }
}

export default NotificationBar;
